import type { EditorPlugin } from '../../types/aha-editor';
import HideInline from './Components/HideInline';

const HideInlinePlugin: EditorPlugin = {
  name: 'Hide inline component plugin',
  schema: {
    'hide-inline': {
      isInline: true,
    },
  },
  component: {
    type: 'hide-inline',
    component: HideInline,
  },
};

export default HideInlinePlugin;
